import VueSmoothScroll from 'vue2-smooth-scroll';

export default VueSmoothScroll;
